import {AddressForm} from "@/app/components/form/definitions/address.form";
import {TableFilter} from "@/enum/table_filter";

function SupplierForm() {
    return {
        name: '',
        ico: null,
        dic: null,
        phone: null,
        email: null,
        website: null,
        billing_address: new AddressForm
    };
}

function SupplierRender() {
    return {
        ico: {
            icon: '$ico',
            type: 'number',
            max: 30,
            appendOuter: true
        },
        name: {
            icon: '$itemName',
            max: 100,
            required: true
        },
        dic: {
            icon: '$dic',
            max: 30
        },
        phone: {
            icon: '$phone',
            type: 'number',
            max: 20
        },
        email: {
            icon: '$email',
            type: 'email',
            max: 50
        },
        website: {
            icon: '$website'
        }
    };
}

const supplierTable = {
    name: {
        filterType: TableFilter.TEXT
    },
    ico: {
        filterType: TableFilter.NUMBER
    },
    dic: {
        filterType: TableFilter.TEXT
    },
    phone: {
        filterType: TableFilter.NUMBER
    },
    email: {
        filterType: TableFilter.TEXT
    },
    website: {
        filterType: TableFilter.TEXT
    }
};

export {SupplierForm, SupplierRender, supplierTable};
